import { Component, Input, OnInit } from '@angular/core';
import { AppLauncher } from '@capacitor/app-launcher';
import { Browser } from '@capacitor/browser';
import { ModalController, PopoverController } from '@ionic/angular';
import { PlansService } from 'src/app/services/plans.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import { TermsComponent } from '../terms/terms.component';
import { VideoPlayComponent } from '../video-play/video-play.component';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-wa-button',
  templateUrl: './wa-button.component.html',
  styleUrls: ['./wa-button.component.scss'],
})
export class WaButtonComponent implements OnInit {
  browser: any;
  waPhone: string = '';
  videoUrl: string = '';
  isGeneralVersion = environment.isGeneralVersion;
  instagramUser: string = '';
  platform: string;
  waText: any;

  @Input() type: any;

  constructor(
    public modalController: ModalController,
    public popoverController: PopoverController,
    private plansService: PlansService,
    private userService: UserService,
  ) {
    this.platform = Capacitor.getPlatform();
  }

  async ngOnInit() {
    const settings = await this.plansService.getStorageSettings();
    if (settings) {
      this.waPhone = settings.whatsapp_phone;
      this.waText = settings.texto_contacto_whatsapp;
    } else {
      this.getVideo();
    }

    this.getVideo();
  }

  getVideo() {
    this.userService.getSettings().subscribe(
      (res: any) => {
        this.videoUrl = this.isGeneralVersion ?  res.data.welcome_video_url : res.data.welcome_video_url_personal;
        this.waPhone = res.data.whatsapp_phone;
        this.instagramUser = res.data.instagram_account.replace('@', '');
        this.waText = res.data.texto_contacto_whatsapp;
        this.plansService.saveSettings(res.data);
      },
      (err) => {
        console.log(err);
      }
    );
  }
  async openVideo() {
    const modal = await this.modalController.create({
      component: VideoPlayComponent,
      cssClass: 'my-custom-class',
      componentProps: { videoUrl: this.videoUrl, youtube: true, from: 'tabs' },
    });

    // modal.onDidDismiss().then((data) => {

    // });
    return await modal.present();
  }
  async openAbout(page) {
    const modal = await this.modalController.create({
      component: TermsComponent,
      cssClass: 'my-custom-class',
      componentProps: {
        initialPage: page,
      },
    });
    modal.onDidDismiss().then(async (data) => {
      console.log(data);
    });
    return await modal.present();
  }
  socialMedia(type) {
    switch (type) {
      case 'instagram':
        this.openInstagram(this.instagramUser);
        break;
      case 'whatsapp':
        this.openWhatsapp(this.waPhone);
        break;

      default:
        break;
    }
  }
  async openInstagram(name: string) {
    const appScheme = 'instagram://';
    const appUrl = `instagram://user?username=${name}`;
    const webUrl = `https://www.instagram.com/${name}`;

    if (this.platform === 'web') {
      window.open(webUrl, '_blank');
      return;
    }

    try {
      const result = await AppLauncher.canOpenUrl({ url: appScheme });

      if (result.value) {
        await AppLauncher.openUrl({ url: appUrl });
      } else {
        await Browser.open({ url: webUrl });
      }
    } catch (err) {
      await Browser.open({ url: webUrl });
    }
  }

  async openWhatsapp(number: string) {
    const appScheme = 'whatsapp://';
    const text = this.waText || '';
    const appUrl = `whatsapp://send?phone=${number}&text=${encodeURIComponent(text)}`;
    const webUrl = `https://api.whatsapp.com/send?phone=${number}&text=${encodeURIComponent(text)}`;

    if (this.platform === 'web') {
      window.open(webUrl, '_blank');
      return;
    }

    try {
      const result = await AppLauncher.canOpenUrl({ url: appScheme });

      if (result.value) {
        await AppLauncher.openUrl({ url: appUrl });
      } else {
        await Browser.open({ url: webUrl });
      }
    } catch (err) {
      await Browser.open({ url: webUrl });
    }
  }


}
